import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { CheckItem } from '../CheckItem';
import { ProductImage } from '../ProductImage';
import { offerIncludes, PRICE } from '../../data/salesContent';
export function OfferSection() {
  return;
}